export default "__VITE_ASSET__BFG1GYCr__"